import React, { useContext, useState } from "react";
import {
  OverlayTrigger,
  Tooltip,
  InputGroup,
  Image,
  Button,
} from "react-bootstrap";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import {
  SearchableList,
  FieldDropSide,
  SliderPanel,
  ManageRkaasLayout,
  CsplTable as Table,
  LoaderWrapper,
  FormControlSearch,
} from "../../../../components";
import {
  MANAGE_RKAAS_ROUTES,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  INVESTMENT_RECORDS_TO_FETCH,
} from "../../../../utils";
import {
  manageRkaasStore,
  MANAGE_RKAAS_POST_API_ERROR,
} from "../../../../contexts";
import { getMasterInvestmentBySearchCriteria } from "../../../../services";
import { useDeepEffect, useRouterParams } from "../../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import AddInvestmentContainer from "../../Investment/AddInvestmentContainer";
import MasterInvestmentFilter from "../../Investment/ManageInvestment/MasterInvestmentFilter";
import CustodianDetailsCard from "./CustodianDetailsCard";
import {
  faExclamationTriangle,
  faTimes,
  faTrashAlt,
  faPencilAlt,
  faCheckCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Logo from "../../../../assets/netflix-logo-0.png";
import CustodianDetailSlide from "./CustodianDetailSlide";

const CustodianDetails = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageRkaasStore);
  const { flow, custodianId } = useRouterParams();
  const [newFlow, setNewFlow] = useState(
    flow != FLOW_TYPES.ADD
      ? flow != FLOW_TYPES.SAVE
        ? FLOW_TYPES.EDIT
        : FLOW_TYPES.SAVE
      : FLOW_TYPES.ADD
  );
  const [isLoading, setIsLoading] = useState(false);
  const [append, setAppend] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = [
    {
      title: "Custodian Account Number",
      type: "link",
    },
    {
      title: "Associated plan",
      type: "text",
    },
    {
      title: "Description",
      value: "SBI bank",
      type: "text",
    },
  ];
  const mockAccountDetails = [
    {
      custodianAccountNumber: "343546564545",
      associatedPlan: "03",
      description: "SBI bank",
    },
  ];

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.CUSTODIAN,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTimes,
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.INVESTMENT,
      }),
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faPencilAlt,
      onClick: () => {
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
            pathParam: [FLOW_TYPES.SAVE, custodianId],
          })
        );
        setNewFlow(FLOW_TYPES.SAVE);
      },
    },
    {
      label: "",
      variant: "link",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      icon: faTrashAlt,
      link: getPathWithParam({
        path: MANAGE_RKAAS_ROUTES.INVESTMENT,
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  return (
    <ManageRkaasLayout
      layoutHeader="Custodian details"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <>
        <LoaderWrapper isLoading={isLoading}>
          <div className="trade-container">
            <div className="custodian-detail-card">
              <CustodianDetailsCard
                className="custodian-image"
                logoHeight="4rem"
                logoWidth="10rem"
                type="img"
                image={Logo}
              />
              <CustodianDetailsCard
                value={"ABD"}
                title={"BNY Mellon"}
                type="text"
              />
              <CustodianDetailsCard
                value={"ABD"}
                title="Contact number"
                type="text"
              />
              <CustodianDetailsCard value={"ABD"} title="Email" type="text" />
              <CustodianDetailsCard
                value={"ABD"}
                title="Associated plans"
                type="text"
              />
            </div>

            <div className="sub-layout-header">
              <h6>Custodian account details</h6>
            </div>

            {/* <div className="search-bar" style={{ marginBottom: "16px" }}> */}
            <div style={{ marginBottom: "16px" }}>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text className="plan-search-button">
                    <Image src="/assets/icons/svg/search.svg" width="14px" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlSearch
                  type="search"
                  placeholder="Search custodian account number,plan name,plan ID etc"
                  // onChange={(e) => {
                  //   setFieldValue(fields.search, e.target.value);
                  // }}
                />
              </InputGroup>
            </div>

            <div>
              {mockAccountDetails.map((account, index) => {
                return (
                  <div className="custodian-detail-card">
                    {columns.map((item, index) => {
                      if (item.title === "Custodian Account Number") {
                        return (
                          <CustodianDetailsCard
                            className="custodian-account-detail-card"
                            title={item.title}
                            value={account.custodianAccountNumber}
                            type={item.type}
                            onClick={() => setIsModalOpen(!isModalOpen)}
                          />
                        );
                      }
                      if (item.title === "Associated plan") {
                        return (
                          <CustodianDetailsCard
                            className="custodian-account-detail-card"
                            title={item.title}
                            value={account.associatedPlan}
                            type={item.text}
                          />
                        );
                      }
                      if (item.title === "Description") {
                        return (
                          <CustodianDetailsCard
                            className="custodian-account-detail-card"
                            title={item.title}
                            value={account.description}
                            type={item.text}
                          />
                        );
                      }
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </LoaderWrapper>
        <SliderPanel isOpen={isModalOpen} size="60" showCancel={false}>
          <div className="d-flex justify-content-between">
            <div className="ft-14 font-weight-500">
              Custodian account details
            </div>
            <div>
              <Button
                type="button"
                variant="secondary"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
          <div className="border-top" />
          <CustodianDetailSlide custodianAccountDetails={mockAccountDetails} />
        </SliderPanel>
      </>
    </ManageRkaasLayout>
  );
};

export default CustodianDetails;
